<template>
  <div>
    <b-row v-if="evaluationData">
      <b-col class="mt-2">
        <div class="cardContainer evaluationHeader" style="padding: 30px">
          <div>
            <h2>
              {{$t(
                  isReport
                    ? "label_evaluation_report_title"
                    : "label_evaluation_evaluationMatrix_overview")}}
              {{evaluationData.evaluation_administrator_evaluations_evaluationName}}
            </h2>
            <template-status v-if="!isReport" style= "position: absolute; right: 40px; top: 40px" :status="getSavingStatus" />
          </div>
          <b-row>
            <b-col style="border-right: 1px solid black; padding: 10px 17px">
              <div>
                <span class="h7">
                  {{
                    $t("label_evaluation_evaluationMatrix_progressByDimension")
                  }}
                </span>
                <div style="white-space: nowrap">
                  {{ data.evaluation_progress }} of
                  <span v-if="data.children">{{ data.children.length }}</span>
                </div>
                <div>
                  <span class="h7">
                    {{ $t("label_evaluation_evaluationMatrix_generalStatus") }}
                  </span>
                  <div style="white-space: nowrap">
                    {{ data.evaluation_status }} %
                  </div>
                </div>
              </div>
            </b-col>
            <b-col style="border-right: 1px solid black; padding: 10px 17px">
              <div>
                <span class="h7">
                  {{$t("label_evaluation_evaluationMatrix_currentAchievedSeal")}}
                </span>
              </div>
              <div>
                <span style="white-space: nowrap">
                  <span>{{ $t(data.achievedSeal) }}</span>
                </span>
              </div>
              <div>
                <span class="h7">
                  {{$t("label_evaluation_evaluationMatrix_previousSeal") }}
                </span>
              </div>
              <div>
                <span style="white-space: nowrap">{{
                  evaluationData.evaluation_evaluationMatrix_previousSeal
                }}</span>
              </div>
            </b-col>
            <b-col style="border-right: 1px solid black; padding: 10px 17px">
              <div>
                <span class="h7">
                  {{ $t("label_evaluation_evaluationMatrix_lastUpdated") }}
                </span>
              </div>
              <div style="white-space: nowrap">
                {{ evaluationData.evaluation.evaluation_last_updated }}
              </div>
              <div>
                <span class="h7">
                  {{ $t("label_evaluation_evaluationMatrix_traceabilityNumber") }}
                </span>
              </div>
              <div style="white-space: nowrap">
                {{evaluationData.evaluation_administrator_evaluations_traceability}}
              </div>
            </b-col>
            <b-col style="padding: 10px 17px">
              <div>
                <span class="h7">
                  {{ $t("label_evaluation_evaluationMatrix_assignedEvaluators") }}
                </span>
              </div>
              <div>
                <span
                  v-for="(evaluatior, index) in evaluationData.evaluation_administrator_evaluations_assignEvaluator"
                  :key="index"
                >
                  <span v-if="index > 0">, </span>{{ evaluatior.name }}
                  {{ evaluatior.lastName }}</span
                >
              </div>
            </b-col>
          </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="3" />
              <b-col cols="3" style="text-align: left">
                <span class="h7">{{
                  $t("label_evaluation_evaluationProgress")
                }}</span>
              </b-col>
              <b-col cols="3">
                <b-progress
                  v-if="data.evaluationLeafProgress"
                  :max="100"
                  class="progressBarCustom"
                >
                  <b-progress-bar
                    :value="
                      100 *
                      (data.evaluationLeafProgress.totalEvaluated /
                        data.evaluationLeafProgress.totalChildren)
                    "
                    :label="`${(
                      100 *
                      (data.evaluationLeafProgress.totalEvaluated /
                        data.evaluationLeafProgress.totalChildren)
                    ).toFixed(0)}%`"
                  />
                </b-progress>
              </b-col>
            </b-row>
            <b-col cols="3" />
              <evaluation-header-metadata  v-if="!isReport" :evaluationData = "evaluationData" :organizations="organizations"/>
          </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EvaluationHeaderMetadata from "./EvaluationHeaderMetadata"
export default {
  name: "EvaluationModelHeader",
  components: {EvaluationHeaderMetadata},
  props: {
    evaluationData: {
      type: Object,
      default: () => {},
    },
    organizations: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    isReport: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters(["getSavingStatus"]),
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/variables";
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
.cardContainer h5 {
  text-align: center;
  width: 100%;
}
h2 {
  position: relative;
  text-align: center;
  color: black !important;
  margin: 1em 0;
  margin-bottom: 20px;
  margin-top: 0px;
  left: 15%;
  right: 15%;
  max-width: 70% !important;
}
.label {
  font-weight: bold;
  font-size: 14px;
}
.h7 {
  font-weight: bold;
  margin-top: 15px;
}
.evaluationHeader {
  h2 {
    color: #212529 !important;
  }
}
</style>
<style lang="scss">
.progressBarCustom {
  border-radius: 0px;
  border: 1px solid #000000;
  height: 25px;
  background: #ffffff;

  .progress-bar {
    color: #000000;
    background-color: #91dbda;
    font-weight: bolder;
  }
}
</style>
